import React, { Component } from "react";
import { Button } from "@blueprintjs/core";
import { Spinner } from "@blueprintjs/core";
import { TASK_STATUS_COLOR } from "../constants";
import PMDesktopWindow from "./PMDesktopWindow";
import PMTGSTask from "../new/TaskGroup/PMTGSTask";

class PMDesktopTasks extends Component {

	loading = () => {
		return <div style={{ textAlign: 'center' }}>
			<Spinner />
		</div>;
	}

	render() {
		const p = this.props;

		return (
			<div className="PMTasks">
				<h2 >
					<span className="subpage_content_header_title">Tasks</span>
				</h2>

				{p.currentPhase !== null ? this.proceedButton() : null}

				{p.isLoading === true ? this.loading() : this.list()}
			</div>
		);
	}

	proceedButton = () => {
		const btnStyle = { // TODOCSS
			'marginTop': '0px',
			'paddingTop': '24px',
			'textAlign': 'center',
			'marginBottom': '24px',
		}
		return <div className="projectmanager_button_row" style={btnStyle}>
			<Button
				large
				icon="arrow-left"
				title="Back"
				intent="primary"
				onClick={this.props.goBack}
			>
				Back
			</Button>
		</div>
	}

	list = () => {
		const p = this.props;
		if (p.editMode === 'none') {
			return p.storedTasks.map((task, i) => {
				if (p.currentTask !== i && task.phaseID == p.currentItem.uniqueID && !task.hidden) {
					return <PMDesktopWindow
						color={TASK_STATUS_COLOR[task.status]}
						index={i}
						key={i}
						window={task.window}
						data={task}
						funcMoveZ={this.props.funcMoveZ}
						funcResize={this.props.funcResize}
						funcRemoveWindow={this.props.funcRemoveWindow}
					>

						<PMTGSTask
							color={TASK_STATUS_COLOR[task.status]}
							task={task}
							selectEditTask={p.selectEditTask}
							index={i}
							key={task.uniqueID + '_' + i}
						/>

					</PMDesktopWindow>
				} else {
					return null
				}
			});
		}

	};


}

export default PMDesktopTasks;



// WEBPACK FOOTER //
// ./src/components/projectmanager/desktop/PMDesktopTasks.jsx